export const sortModalState = {}
